export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M3 5h2v6h5V5h2v14h-2v-6H5v6H3zm14 12V7h-2c0-.92 1.024-2 2-2h2v12h2v2h-6v-2z\"/>"
};